import * as externalCourseAPI from '@adobe/edex/frontend/api/externalCourse';

const externalCourseModule = {
  namespaced: true,
  state: {
    externalCourse: null,
    loading: false,
    liveCourseIfExist: null,
  },
  mutations: {
    setExternalCourse: (state, data) => {
      state.externalCourse = data;
      state.loading = false;
    },
    setLiveCourse: (state, data) => {
      state.liveCourseIfExist = data;
      state.loading = false;
    },
    setLoading(state) {
      state.loading = true;
    },
    resetState(state) {
      state.externalCourse = null;
      state.loading = false;
      state.staff = null;
    },
  },
  actions: {
    async fetchShellCourseByID({ commit }, id) {
      commit('setLoading');
      const { data: externalCourse } = await externalCourseAPI.fetchCourse(id);
      commit('setExternalCourse', externalCourse);
    },
    async updateCourse({ commit }, params) {
      commit('setLoading');
      const { data } = await externalCourseAPI.updateCourse(params.shellCourseID, params.payload);
      commit('resetState');
      commit('setExternalCourse', data);
    },
    async fetchLiveShellCourseFromDraftCourseID({ commit }, id) {
      commit('setLoading');
      const { data: liveCourse } = await externalCourseAPI.fetchLiveCourseFromDraftCourseID(id);
      commit('setLiveCourse', liveCourse);
    },
  },
};

export default externalCourseModule;
